import Nullstack from 'nullstack';
export default function IconZodiacAries({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-zodiac-aries",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M12 5a5 5 0 1 0 -4 8"
  }), "   ", Nullstack.element("path", {
    d: "M16 13a5 5 0 1 0 -4 -8"
  }), "   ", Nullstack.element("line", {
    x1: "12",
    y1: "21",
    x2: "12",
    y2: "5"
  }), " ");
}